import { Z_INDEX_THIRD } from '../../../../legacy/common/theme'

export const navBarHeight = 48

// Z_INDEX_THIRD is used for all modals overlay (makes the rest of the page disabled), and we want the menu bar to be just below it
export const MENU_BAR_Z_INDEX = Z_INDEX_THIRD - 1
